import React from "react";
import { Link } from 'react-router';
//import NavigationMenuSearch from "./NavigationMenuSearch";
import API from "../base/API";
import Storage from "../base/Storage";
import { translate } from "../base/Translation";
import AutoAffix from 'react-overlays/lib/AutoAffix';

export default class NavigationMenu extends React.Component {

    constructor(props) {
        super(props);

        this.api = new API({
            get_allowed_components: "/user/fetch/allowed_components",
        });

        this.state = {
            allowedComponents: [],
            activeMenus: []
        }
    }

    fetchAllowedComponents() {
        this.api.request({
            cache: true,
            route: "get_allowed_components",
            success: function (response) {
                this.setState({ allowedComponents: response });
                Storage.set("allowed_components", response);
            }.bind(this)
        });
    }

    componentDidMount() {
        this.fetchAllowedComponents();
    }

    toggle(identifier) {

        let activeMenus = this.state.activeMenus;

        const index = activeMenus.indexOf(identifier);

        if (index < 0) {
            activeMenus.push(identifier);
        } else {
            activeMenus.splice(index, 1);
        }

        this.setState({ activeMenus });
    }

    renderMainMenu(title, icon, link) {
        return (
            <li>
                <Link to={link} activeClassName="current"><i className={"fa " + icon + " fa-fw"} /> {title}</Link>
            </li>
        )
    }

    weaveGroupMenu(ac) {
        if (ac.indexOf("WeaveGroupList") > -1) {
            return this.renderMainMenu(translate("Skupiny vĺn"), "fa-object-group", "/weave_groups");
        }
    }

    formsMenu(ac) {
        if (ac.indexOf("Forms") > -1) {
            return this.renderMainMenu(translate("Dotazníky"), "fa-file", "/forms");
        }
    }

    weavesMenu(ac) {

        if (ac.indexOf("Weaves") > -1) {
            return this.renderMainMenu(translate("Vlny"), "fa-refresh", "/weaves");
        }

        return "";
    }

    testsMenu(ac) {

        if (ac.indexOf("Tests") > -1) {
            return this.renderMainMenu(translate("Testy"), "fa-check-square-o", "/tests");
        }

        return "";
    }

    translationsMenu(ac) {

        if (ac.indexOf("TranslationList") > -1) {
            return this.renderMainMenu(translate("Preklady"), "fa-globe", "/translations");
        }

        return "";
    }

    formStatisticsMenu(ac) {

        if (ac.indexOf("StatisticList") > -1) {
            return this.renderMainMenu(translate("Štatistika dotazníkov"), "fa-bar-chart", "/statistics");
        }

        return "";
    }

    topBottomStatisticsMenu(ac) {

        if (ac.indexOf("TopBottom10") > -1) {
            return this.renderMainMenu(translate("Top / bottom 10"), "fa-bar-chart", "/top_bottom");
        }

        return "";
    }

    statisticsMenu(ac) {
        const isActive = this.isActiveMenu("statisticsMenu");
        let activeLiClass = isActive ? " active" : "";
        let activeUlClass = "nav nav-second-level collapse" + (isActive ? " in" : "");

        if (ac.indexOf("StatisticList") === -1) {
            return null;
        }

        return (
            <li className={activeLiClass}>
                <a style={{ cursor: "pointer" }} onClick={() => { this.toggleMenu("statisticsMenu") }}>
                    <i className="fa fa-bar-chart"></i> {translate("Štatistiky")}<span className="fa arrow"></span>
                </a>
                <ul className={activeUlClass} ref="weavesSettingsMenu">
                    {this.formStatisticsMenu(ac)}
                    {this.topBottomStatisticsMenu(ac)}
                </ul>
            </li>
        )
    }

    branchesMenu(ac) {

        if (ac.indexOf("BranchList") > -1) {
            return this.renderMainMenu(translate("Prevádzky"), "fa-home", "/branches");
        }

        return "";
    }

    brandsMenu(ac) {

        if (ac.indexOf("BrandList") > -1) {
            return this.renderMainMenu(translate("Značky"), "fa-tags", "/brands");
        }

        return "";
    }


    usersMenu(ac) {

        if (ac.indexOf("UserList") > -1) {
            return this.renderMainMenu(translate("Používatelia"), "fa-user", "/users");
        }

        return "";
    }

    usersExternalMenu(ac) {

        if (ac.indexOf("UserList") > -1) {
            return this.renderMainMenu(translate("Mystery Shopperi"), "fa-user", "/mysteryshoppers");
        }

        return "";
    }

    clientsMenu(ac) {

        if (ac.indexOf("ClientList") > -1) {
            return this.renderMainMenu(translate("Klienti"), "fa-user", "/clients");
        }

        return "";
    }

    mailLogMenu(ac) {
        if (ac.indexOf("MailLogList") > -1) {
            return this.renderMainMenu(translate("Mail Log"), "fa-envelope", "/mail_log");
        }

        return "";
    }

    weavesSettingsMenu(ac) {
        const isActive = this.isActiveMenu("weavesSettingsMenu");
        let activeLiClass = isActive ? " active" : "";
        let activeUlClass = "nav nav-second-level collapse" + (isActive ? " in" : "");

        if (ac.indexOf("Weaves") === -1 && ac.indexOf("Forms") === -1 && ac.indexOf("ProtocolList") === -1) {
            return null;
        }

        return (
            <li className={activeLiClass}>
                <a style={{ cursor: "pointer" }} onClick={() => { this.toggleMenu("weavesSettingsMenu") }}>
                    <i className="fa fa-wrench"></i> {translate("Nastavenie vlny")}<span className="fa arrow"></span>
                </a>
                <ul className={activeUlClass} ref="weavesSettingsMenu">
                    {this.weaveGroupMenu(ac)}
                    {this.weavesMenu(ac)}
                    {this.formsMenu(ac)}
                </ul>
            </li>
        )
    }

    isActiveMenu(menu) {
        return this.state.activeMenus.indexOf(menu) !== -1;
    }

    toggleMenu(menu) {
        let activeMenus = this.state.activeMenus;

        if (this.isActiveMenu(menu)) {
            activeMenus.splice(activeMenus.indexOf(menu), 1);
        } else {
            activeMenus.push(menu);
        }

        this.setState({ activeMenus });
    }

    render() {

        const ac = this.state.allowedComponents;

        return (

            <div className="navbar-default sidebar" role="navigation">
                <div className="sidebar-nav navbar-collapse">
                    <AutoAffix affixClassName="affixed">
                        <ul className="nav" id="side-menu">
                            {/*<NavigationMenuSearch />*/}
                            <li>
                                <Link to="/"><i className="fa fa-dashboard fa-fw" /> {translate("Hlavný panel")}</Link>
                            </li>
                            {this.weavesSettingsMenu(ac)}
                            {this.testsMenu(ac)}
                            {this.statisticsMenu(ac)}
                            {this.branchesMenu(ac)}
                            {this.clientsMenu(ac)}
                            {this.brandsMenu(ac)}
                            {this.usersMenu(ac)}
                            {this.usersExternalMenu(ac)}
                            {this.translationsMenu(ac)}
                            {this.mailLogMenu(ac)}
                        </ul>
                    </AutoAffix>
                </div>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/navigation/NavigationMenu.js